import axios from "axios";
import API_URL from "@/constants/API_URL";
import API_V2_URL from "@/constants/API_V2_URL";

const DocumentTypeService = {
  all({ page, limit, q, status }) {
    return axios.get(
      `${API_V2_URL()}/system/document_types?page=${page}&status=${status}&limit=${limit}&q=${q}`
    );
  },
  show(id) {
    return axios.get(`${API_V2_URL()}/system/document_types/${id}`);
  },
  config() {
    return axios.get(`${API_V2_URL()}/system/document_types/config`);
  },
  create(formData) {
    return axios.post(`${API_V2_URL()}/system/document_types`, formData);
  },
  update(formData, id) {
    return axios.put(`${API_V2_URL()}/system/document_types/${id}`, formData);
  },
  getEmployee(id) {
    return axios.get(`${API_URL()}/users/${id}`);
  }
};

export default DocumentTypeService;



// WEBPACK FOOTER //
// ./src/services/system/DocumentTypeService.js